/**
 * JS for articles (is_single() or is_singular())
 */
import { ComponentManager } from 'js-component-framework';

// Import components and manager here
import footnotesConfig from '../components/Footnotes/footnotesConfig';
import carouselConfig from '../components/Carousel/carouselConfig';
import articleToolbarConfig from '../components/Header/articleToolbarConfig';
import buttonCTAConfig from '../components/ButtonCTA/buttonCTAConfig';
import contactForm from './contactForm';
import applySelectorToOEmbeds from './applySelectorToOEmbeds';
import dynamicIframeConfig from '../components/DynamicIframe';

// Import SCSS
import '../../scss/article/loader.scss';

// Negotiate the document.domain.
if (document.domain.match(/\.prb\.org$/)) {
  document.domain = 'prb.org';
} else if (document.domain.match(/\.alley\.dev$/)) {
  document.domain = 'alley.dev';
}

// Create instance of the component manager using `wp-starter-theme`
const manager = new ComponentManager('prb-2017');

const components = [
  footnotesConfig,
  carouselConfig,
  articleToolbarConfig,
  buttonCTAConfig,
  dynamicIframeConfig,
];

// Initialize components here
document.addEventListener('DOMContentLoaded', () => {
  applySelectorToOEmbeds();
  manager.initComponents(components);
  contactForm();
});

// HMR Acceptance
if (module.hot) {
  module.hot.accept();
  applySelectorToOEmbeds();
  manager.initComponents(components);
}



// WEBPACK FOOTER //
// ./client/js/article/article.js